<div class="responsive-card d-flex flex-column">
  <span class="upload-title">{{ cardTitle }}</span>
  <div i18n>
    A template for new {{ memberType }} information can be downloaded
    <button (click)="downloadTemplate()" type="button" class="no-style-button download-button">here.</button>
  </div>
  <form [formGroup]="formGroup">
    <label for="file" i18n>File Upload</label>
    <app-file-upload-field
      formControlName="file"
      [control]="formGroup.controls.file"
      [inputName]="'file'"
      [accept]="['text/csv', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/dat']"
      [interceptPreviewClick]="true"
      [maxFileSizeInMb]="3"
      [interceptRemoveClick]="true"
      (previewClicked)="openPreviewModal($event)"
      (removeClicked)="onRemoveFile()">
      <ng-container input-copy>
        <img height="24" src="assets/icons/grey/FileUpload.svg" alt="Upload File" i18n-alt />
        <app-file-uploader-text descriptionText=".csv, .dat, and .xlsx up to 3 MB" i18n-descriptionText />
      </ng-container>
    </app-file-upload-field>
    <span class="error-text" *ngIf="hasFormattingError$ | async" i18n>Formatting Issues Detected</span>
  </form>
  <hr [style.margin]="'0.5rem 0'" />
  <div class="d-flex justify-content-end gap-3 mt-2">
    <app-button (buttonClick)="skipFileUpload()" [type]="ButtonTypeEnum.secondary" i18n>
      Create without Template
    </app-button>
    <app-button *ngIf="formGroup.valid" (buttonClick)="submitForm()" [type]="ButtonTypeEnum.primary" i18n>
      Continue
    </app-button>
  </div>
</div>
